import DefaultTemplate from "components/templates/DefaultTemplate";
import {
    sendEmailVerification,
    createUserWithEmailAndPassword,
    signOut,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "firebaseConfig";
import { useState } from "react";

const Signup = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rePassword, setRePassword] = useState("");

    /**
     * サインアップした後、認証メールを送信し、DBにデータを登録する
     * @param mail メールアドレス
     * @param pass パスワード
     * @returns 正常に終了したらresolveされるPromise
     */
    const signup = (mail: string, pass: string): Promise<void> => {
        return new Promise((resolve, reject) => {
            createUserWithEmailAndPassword(auth, mail, pass)
                .then((u) => {
                    const user = u.user;
                    sendEmailVerification(user, {
                        url: "http://tic-s3.web.app/login",
                    })
                        .then(async () => {
                            await setDoc(doc(db, `users/${user.uid}`), {
                                type: "user",
                            });
                            signOut(auth);
                            resolve();
                        })
                        .catch((e) => {
                            reject(`メール送信に失敗しました\n${e.code}`);
                        });
                })
                .catch((e) => {
                    reject(`アカウント作成に失敗しました\n${e.code}`);
                });
        });
    };

    return (
        <DefaultTemplate className="login">
            <form
                name="signup_form"
                id="signupForm"
                style={{ height: "100%" }}
                onSubmit={(e) => {
                    e.preventDefault();
                    signup(email, password);
                }}
            >
                <div className="signup_form_top">
                    <h1>SIGNUP</h1>
                    <p>
                        UserID、Passwordをご入力の上、「SIGNUP」ボタンをクリックしてください。
                    </p>
                </div>
                <div className="login_form_btm">
                    <input
                        type="email"
                        name="email"
                        placeholder="Mail Address"
                        id="email"
                        className="signup"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        id="password"
                        className="signup"
                        minLength={6}
                        maxLength={20}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type="password"
                        name="passwordcheck"
                        placeholder="Passwordcheck"
                        id="passwordCheck"
                        className="signup"
                        minLength={6}
                        maxLength={20}
                        value={rePassword}
                        onChange={(e) => setRePassword(e.target.value)}
                    />
                    <input
                        type="submit"
                        className="signup"
                        name="botton"
                        value="SIGNUP"
                    />
                </div>
            </form>
        </DefaultTemplate>
    );
};

export default Signup;
